import { jimJobConfigsByType } from '../../config';
import { Job } from './types';


export const isExportTypeJob = (job: Job) => {
  const jobConfig = jimJobConfigsByType[job.jobType];
  return Boolean(jobConfig && 'returnsFile' in jobConfig && Boolean(jobConfig?.returnsFile));
};

export const isCsvExportJob = (job: Job) => job.returnedValue?.exportFormat === 'csv';

export const shouldDownloadJobAsZip = (job: Job, isZipFile?: boolean) =>
  Boolean(isZipFile) || isCsvExportJob(job);
